import { Box, TextField } from '@mui/material';
import { Edit } from '@refinedev/mui';
import { useForm } from '@refinedev/react-hook-form';
import { Controller } from 'react-hook-form';

const CloudProvidersEdit = () => {
  const {
    refineCore: { formLoading },
    control,
    saveButtonProps,
    formState: { errors }
  } = useForm();

  return (
    <Edit isLoading={formLoading} saveButtonProps={saveButtonProps}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }} component="form" autoComplete="off">
        <Controller
          rules={{ required: 'Cloud provider name is required' }}
          control={control}
          name="name"
          render={({ field: { onChange, value } }) => (
            <TextField
              value={value || ''}
              onChange={onChange}
              required
              error={!!errors.name}
              helperText={errors.name?.message as string}
              label="Cloud Provider Name"
              autoFocus
              fullWidth
            />
          )}
        />
      </Box>
    </Edit>
  );
};

export default CloudProvidersEdit;
